import { Button, Col, Row, Typography } from "antd";
import CustomTag from "./Tags/CustomTag";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import { formatNumber, formatTimeSpan, minutesToSeconds } from "src/utils/formatting";
import { convertFahrenheitToCelsius } from "src/utils/generalUtils";

const { Text } = Typography;

interface ReconditioningPageStateTableProps
{
    binDto: PremierPlusBinDTO | null | undefined;
}

const ReconditioningPageStateTable : React.FC<ReconditioningPageStateTableProps> = ({ binDto }) => {

    const valueTextStyle = {
        fontFamily:'monospace',
        fontWeight:'bolder'
    }

    const labelTextStyle={
        fontWeight:'bold',
        fontSize:'13px'
    }

    const reconditioning = binDto?.reconditioningOperation;

    const useCelsius = useMemo ( () => {
        return binDto?.platformSettings?.useMetricSystem;
    }, [binDto]);
    const doubleCellSpan = 5;

    return(
        <div>
            <Row align="middle">
                <Col span={doubleCellSpan - 1} className="title-cell">
                    <Text style={labelTextStyle}>Bin Name:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={{ fontWeight:'bolder' }}>{reconditioning?.targetStorageBin?.name ?? 'Unknown'}</Text>
                </Col>
                <Col span={doubleCellSpan} className="title-cell">
                    <Text style={{...labelTextStyle, fontSize:'12px'}}>Minutes to next sample</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>{formatTimeSpan(minutesToSeconds(reconditioning?.minutesToNextSample))}</Text>
                </Col>
            </Row>

            <Row>
                <Col span={doubleCellSpan - 1} className="title-cell">
                    <Text style={labelTextStyle}>Machine:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    {reconditioning?.isReconditioningRunning ?
                    <CustomTag icon={<CheckCircleOutlined />} label="ON" color={"green"}/> :
                    <CustomTag icon={<CloseOutlined />} label="OFF" color={"red"}/>}
                </Col>
                <Col span={doubleCellSpan} className="title-cell">
                    <Text style={labelTextStyle}>Cont. Flow/Aux Augers</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    {
                        binDto?.augers?.[0]?.isOn ?
                        <CustomTag icon={<CheckCircleOutlined />} label="ON" color={"green"}/>
                        :
                        <CustomTag icon={<CloseOutlined />} label="OFF" color={"red"}/>
                    }
                </Col>
            </Row>

            <Row>
                <Col span={doubleCellSpan - 1} className="title-cell">
                    <Text style={labelTextStyle}>Trans Moisture:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>{formatNumber(reconditioning?.targetMcPercent, { decimalPlaces: 1 })} %</Text>
                </Col>
                <Col span={doubleCellSpan} className="title-cell">
                    <Text style={labelTextStyle}>Grain Temp:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>
                        {`${formatNumber(useCelsius ? convertFahrenheitToCelsius(reconditioning?.lastSampleTemperatureF) : reconditioning?.lastSampleTemperatureF, {decimalPlaces: 0, suffix: useCelsius ? " °C" : " °F"})}`}
                    </Text>
                </Col>
            </Row>

            <Row>
                <Col span={doubleCellSpan - 1} className="title-cell">
                    <Text style={labelTextStyle}>Actual Plenum MC:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>{formatNumber(reconditioning?.actualPlenumMc, { decimalPlaces: 1 })} %</Text>
                </Col>
                <Col span={doubleCellSpan} className="title-cell">
                    <Text style={labelTextStyle}>Actual Plenum Temp:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>
                        {`${formatNumber(useCelsius ? convertFahrenheitToCelsius(reconditioning?.actualPlenumTemperatureF) : reconditioning?.actualPlenumTemperatureF, {decimalPlaces: 0, suffix: useCelsius ? " °C" : " °F"})}`}
                    </Text>
                </Col>
            </Row>

            <Row>
                <Col span={doubleCellSpan - 1} className="title-cell">
                    <Text style={labelTextStyle}>Moist. Avg:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>{formatNumber(reconditioning?.averageSampleMcPercent, { decimalPlaces: 1 })} %</Text>
                </Col>
                <Col span={doubleCellSpan} className="title-cell">
                    <Text style={labelTextStyle}>Drying Value:</Text>
                </Col>
                <Col span={doubleCellSpan} className="value-cell">
                    <Text style={valueTextStyle}>{formatNumber(reconditioning?.dryingValueInAhDiff, { decimalPlaces: 2 })}</Text>
                </Col>
                <Col className="no-border">
                    <Button
                    type="primary"
                    style={{ fontSize:'11px', fontWeight:'bold', backgroundColor: '#0958d9'}}
                    size="small"
                    >
                        TAPESTRIP VIEWER
                    </Button>
                </Col>
            </Row>
      </div>
    )
}


export default ReconditioningPageStateTable;
